import { useTranslation } from "react-i18next";
import "./Security.css";

const ITEMS = [
  { key: "encryption", icon: "lock" },
  { key: "mfa", icon: "key" },
  { key: "compliance", icon: "shield" },
  { key: "scans", icon: "scan" },
  { key: "disclosure", icon: "broadcast" },
  { key: "researcher", icon: "trophy" },
];

function Icon({ name }) {
  const stroke = { stroke: "currentColor", strokeWidth: 1.6, fill: "none", strokeLinecap: "round", strokeLinejoin: "round" };
  switch (name) {
    case "lock":
      return (
        <svg viewBox="0 0 24 24" {...stroke}>
          <rect x="4" y="11" width="16" height="10" rx="2" />
          <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </svg>
      );
    case "key":
      return (
        <svg viewBox="0 0 24 24" {...stroke}>
          <circle cx="8" cy="14" r="4" />
          <path d="M11 14h10M17 14v3M21 14v3" />
        </svg>
      );
    case "shield":
      return (
        <svg viewBox="0 0 24 24" {...stroke}>
          <path d="M12 3l8 3v5c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-3z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      );
    case "scan":
      return (
        <svg viewBox="0 0 24 24" {...stroke}>
          <path d="M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3" />
          <path d="M4 12h16" />
        </svg>
      );
    case "broadcast":
      return (
        <svg viewBox="0 0 24 24" {...stroke}>
          <circle cx="12" cy="12" r="2" />
          <path d="M8.5 8.5a5 5 0 0 0 0 7M15.5 8.5a5 5 0 0 1 0 7M5 5a10 10 0 0 0 0 14M19 5a10 10 0 0 1 0 14" />
        </svg>
      );
    case "trophy":
      return (
        <svg viewBox="0 0 24 24" {...stroke}>
          <path d="M8 4h8v5a4 4 0 0 1-8 0V4z" />
          <path d="M5 6h3M16 6h3M9 18h6M10 21h4M12 13v5" />
        </svg>
      );
    default:
      return null;
  }
}

export default function Security() {
  const { t } = useTranslation();
  return (
    <section id="seguranca" className="security section">
      <div className="container">
        <header className="security__header">
          <span className="security__eyebrow">{t("security.eyebrow")}</span>
          <h2 className="security__title">{t("security.title")}</h2>
          <p className="security__lead">{t("security.lead")}</p>
        </header>

        <div className="security__grid">
          {ITEMS.map((it) => (
            <article key={it.key} className="sec-card">
              <span className="sec-card__icon">
                <Icon name={it.icon} />
              </span>
              <h3 className="sec-card__title">{t(`security.items.${it.key}.title`)}</h3>
              <p className="sec-card__body">{t(`security.items.${it.key}.body`)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
